import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { CommentContext, CommentContextProvider } from '../../CommentContext';
import LoadableCommentReduxModule from '../../redux/LoadableCommentReduxModule';
var View;
(function(View) {
    View[/** The current user is editing one of their own comments. */ "Editing"] = 'editing';
    View[/** The comment has been marked as spam. */ "Spam"] = 'spam';
    View[/** The comment is hidden for some reason. Likely moderation */ "Hidden"] = 'hidden';
    View[/** Shown when the comment has been orphaned */ "Orphan"] = 'orphan';
    View[/** The usual view when nothing is wrong with the comment and the user isn't editing it. */ "Read"] = 'read';
})(View || (View = {}));
/** Checks a couple flags and spits out the current view we should show for a comment. */ function getCommentView({ comment, isEditing, isPeeking }) {
    const { isSpam, isHidden, isDeleted, isAdminHidden, replies } = comment;
    const isVisible = !isAdminHidden && !isDeleted;
    if (isEditing) {
        return View.Editing;
    } else if (!isPeeking && isSpam && replies !== 0) {
        return View.Spam;
    } else if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return View.Hidden;
    } else if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return View.Orphan;
    } else {
        return View.Read;
    }
}
const CommentSkeletonViewSwitcher = ({ editingView, spamView, hiddenView, orphanView, readView })=>{
    const { comment } = useContext(CommentContext);
    const { isEditing, isPeeking } = useContext(CommentContext);
    const view = getCommentView({
        comment,
        isPeeking,
        isEditing
    });
    switch(view){
        // Fragments here because typescript complains otherwise.
        case View.Editing:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, editingView);
        case View.Spam:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, spamView);
        case View.Hidden:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, hiddenView);
        case View.Orphan:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, orphanView);
        case View.Read:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, readView);
        default:
            return null;
    }
};
CommentSkeletonViewSwitcher.displayName = 'CommentSkeletonViewSwitcher';
/** A skeleton for the various views that a comment preset needs to implement. */ const CommentSkeleton = (_param)=>{
    var { comment, className, onEditingStateChange } = _param, rest = _object_without_properties(_param, [
        "comment",
        "className",
        "onEditingStateChange"
    ]);
    return /*#__PURE__*/ React.createElement(CommentContextProvider, {
        comment: comment,
        onEditingStateChange: onEditingStateChange
    }, /*#__PURE__*/ React.createElement(LoadableCommentReduxModule, null), /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(CommentSkeletonViewSwitcher, rest)));
};
CommentSkeleton.displayName = 'CommentSkeleton';
export default CommentSkeleton;
